export default __webpack_public_path__ + "static/media/humidity.d40c4130.png";